<template>
  <div>
    <!-- 添加产品 -->
    <!-- 添加产品弹框开始 -->
    <div class="main_dialog_one">
      <el-dialog :close-on-click-modal="false"
      :title="titleType"
      :visible.sync="addProDialogVisible"
      :before-close="addProHandleClose"
      width="84.4%"
      center
      top="2vh"
    >
      <el-divider></el-divider>
      <div class="pxDialog">
        <el-form
          :label-position="labelPosition"
          :model="ruleForm"
          ref="ruleForms"
          label-width="130px"
          :rules="rules"
          class="demo-ruleForm"
        >
          <el-form-item class="inputA" label="产品名称:" prop="ProductName">
            <!-- <span class="posiA">*</span> -->
            <el-input disabled v-model="ruleForm.ProductName" placeholder="请输入产品名称"></el-input>
          </el-form-item>
          <el-form-item class="inputA" label="产品简述:">
            <el-input disabled v-model="ruleForm.description" placeholder="请输入产品简述"></el-input>
          </el-form-item>
          <el-form-item class="inputA" label="年龄限制范围:" >
              <div class="form_ages">
                <el-input v-model="ruleForm.age_range_start" disabled placeholder="请输入年龄">
                <template slot="append">
                  岁
                </template>
              </el-input>
              <span>-</span>
              <el-input v-model="ruleForm.age_range_end" disabled placeholder="请输入年龄">
                <template slot="append">
                  岁
                </template>
              </el-input>
              </div>
            </el-form-item>
          <div class="disA">
            <el-form-item label="产品分类:" prop="ProductType">
              <el-select disabled v-model="ruleForm.ProductType" placeholder="请选择产品分类">
                <!-- <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option> -->
                  <el-option
                    v-for="item in typeArr"
                    :key="item.typeid"
                    :label="item.typename"
                    :value="item.typeid"
                  ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="提前预约时间:" v-if="ruleForm.ProductType=='3'">
              <!-- <span class="posiB">*</span> -->
              <div class="disA">
                <el-input disabled v-model="ruleForm.minimumTime">
                </el-input>
                <span>分</span>
              </div>
            </el-form-item>
          </div>
          <div v-if="ruleForm.ProductType==20&&ruleForm.type==0">
              <div class="son_border" v-for="(item,index) in son" :key="index" >
                <el-form-item class="inputA" label="子产品名称:" >
                  <el-input v-model="item.productname_son"  placeholder="请输入子产品名称"></el-input>
                  <!-- <el-select v-model="item.product_son_id" disabled placeholder="请选择产品名称">
                    <el-option
                      v-for="item in tableDataName"
                      :key="item.id"
                      :label="item.product_son_name"
                      :value="item.id"
                    ></el-option>
                  </el-select> -->
                </el-form-item>
                <el-form-item label="子产品数量:" >
                  <el-input v-model="item.son_number" disabled onkeyup="this.value=this.value.replace(/\D|^0/g,'')"  placeholder="请输入子产品数量"></el-input>
                </el-form-item>
                <el-form-item label="子产品价格:" >
                  <el-input v-model="item.price_son" disabled @input="limitNum(item.price_son,index)"  placeholder="请输入子产品价格"></el-input>
                </el-form-item>
                <!-- <el-form-item label="子产品分类:" >
                  <el-select v-model="item.type_son" disabled clearable placeholder="请选择产品分类">
                      <el-option
                        v-for="item in sonOption"
                        :key="item.id"
                        :label="item.typename"
                        :value="item.id"
                      ></el-option>
                  </el-select>
                </el-form-item> -->
              </div>
            </div>
          <div class="disA"  v-if="ruleForm.ProductType=='3'">
            <el-form-item label="营业开始时间:">
              <!-- <span class="posiB">*</span> -->
              <el-time-picker
                disabled
                v-model="ruleForm.openTime"
                placeholder="选择开始时间"
                value-format="HH:mm"
                format='HH:mm'    
              ></el-time-picker>
            </el-form-item>
            <el-form-item label="营业结束时间:">
              <!-- <span class="posiC">*</span> -->
              <el-time-picker
                disabled
                v-model="ruleForm.closeTime"
                placeholder="选择结束时间"
                value-format="HH:mm"  
                format='HH:mm' 
              ></el-time-picker>
            </el-form-item>
          </div>
          <div class="disA"  v-if="ruleForm.ProductType=='3'">
            <el-form-item label="场地类型:">
              <!-- <span class="posiA">*</span> -->
              <el-select disabled  v-model="ruleForm.place" placeholder="请选择场地类型">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="场地编号:">
              <!-- <span class="posiA">*</span> -->
              <el-input disabled v-model="ruleForm.serialNumber" placeholder="请输入产品简述">
                <!-- <template>
                  <slot slot="suffix">分钟</slot>
                </template>-->
              </el-input>
              <span>分</span>
            </el-form-item>
          </div>
          <div class="disB" v-if="ruleForm.type==1">
            <el-form-item label="完善身份证信息:">
              <!-- <span class="posiD">*</span> -->
              <el-radio-group v-model="ruleForm.radio" disabled @change="radioUpdate">
                <el-radio label="0">不需</el-radio>
                <el-radio label="1">需要(一证一单)</el-radio>
                <el-radio label="2">需要(一证多单)</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="身份证刷门禁进入:">
              <!-- <span class="posiE">*</span> -->
              <el-radio-group v-model="ruleForm.radio1" disabled  @change="radioUpdate">
                <el-radio label="1">启用</el-radio>
                <el-radio label="2">不启用</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <el-form-item label="产品描述:">
            <!-- <span class="posiA">*</span> -->
            <div class="proA">
              <!-- <span v-html="ruleForm.Memo"></span> -->
              <quill-editor 
                v-model="ruleForm.Memo" 
                ref="myQuillEditor" 
                disabled
               >
            </quill-editor>
            </div>
          </el-form-item>
          <div class="fpCss">
            <el-form-item label="发票开具说明:" prop="Invoice">
              <quill-editor 
              disabled
                v-model="ruleForm.Invoice" 
                ref="myQuillEditor" 
              >
            </quill-editor>
            </el-form-item>
          </div>
          <div class="proFm">
            <el-form-item label="产品封面:">
              <el-upload
                disabled
                class="avatar-uploader"
                action="http://xwt.softykt.net/api/product/uploadInfoRemit"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :data="datas">
                <img v-if="ruleForm.WebPic" :src="ruleForm.WebPic" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon">
                </i>
              </el-upload>
            </el-form-item>
          </div>
          <span class="spanB">
              <span>注:</span>
              <span>请上传1M以下的图片(此图片用于平台餐品宣传,请认真对待),支持png,jpg,jpeg</span>
          </span>
          <el-form-item label="产品主图:" >
            <!-- {{ hideUpload?'hide':'1' }} -->
            <el-upload action="http://xwt.softykt.net/api/product/uploadInfoRemit"
              :limit="5"
              disabled
              :class="hideUpload?'hide':'width172'"
              :on-success="attachUploadSuccess"
              :data="datas" list-type="picture-card"
              ref="pictureUpload"
              :file-list="transDetImgList">
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{file}">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
                  <span class="el-upload-list__item-actions">
                    <span
                      v-if="!disabled"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
          </el-form-item>

          <div class="disF">
            <el-form-item label="门市价:" prop="Price">
              <!-- <span class="posiF">*</span> -->
              <el-input disabled v-model="ruleForm.Price"></el-input>
            </el-form-item>
            <span>元</span>
            <!-- <el-button>计算销售/代理价</el-button> -->
          </div>
          <div class="disG">
            <el-form-item label="建议销售价:" prop="SellPrice">
              <!-- <span class="posiG">*</span> -->
              <el-input disabled v-model="ruleForm.SellPrice"></el-input>
            </el-form-item>
            <span>元</span>
            <el-form-item label="代理价:" prop="AgentPrice">
              <!-- <span class="posiF">*</span> -->
              <el-input disabled v-model="ruleForm.AgentPrice"></el-input>
            </el-form-item>
            <span>元</span>
          </div>
          <div class="disH">
            <el-form-item label="押金金额:" prop="Deposit">
              <!-- <span class="posiA">*</span> -->
              <el-input disabled v-model="ruleForm.Deposit"></el-input>
            </el-form-item>
            <span>元</span>
            <el-form-item label="退票:">
              <!-- <span class="posiZ">*</span> -->
              <el-radio-group disabled v-model="ruleForm.ReturnFlag">
                <el-radio label="1">禁止退票</el-radio>
                <el-radio label="0">允许退票</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="disL">
            <el-form-item label="用户限购:">
              <!-- <span class="posiL">*</span> -->
              <el-input disabled v-model="ruleForm.limit_buy" placeholder="请输入限购数量"></el-input>
            </el-form-item>
            <span>0为不限制数量 注：每个用户限购数量</span>
          </div>
          <el-form-item label="产品模式:" prop="type">
            <el-radio-group v-model="ruleForm.type" disabled>
              <el-radio label="0">期票模式</el-radio>
              <el-radio label="1">日历模式</el-radio>
            </el-radio-group>
          </el-form-item>
          
          <div class="disE">
            <el-form-item label="销售有效期:">
              <el-radio-group v-model="ruleForm.ValidStatus" disabled >
                <!-- <el-radio label="1" v-if="ruleForm.type==0">无</el-radio> -->
                <el-radio label="2">设置</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="ruleForm.ValidStatus=='2'">
              <el-date-picker
                v-model="ValidTime"
                disabled
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </div>
          <el-form-item label="消费日期状态:" v-if="ruleForm.type==0" prop="ConsumeState">
            <!-- <span class="posiA">*</span> -->
            <!-- <div> -->
            <el-radio-group disabled v-model="ruleForm.ConsumeState" >
              <el-radio label="1">景区设置</el-radio>
              <el-radio label="2">生效时间设置</el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="disW" v-if="ruleForm.ConsumeState==2&&ruleForm.type==0">
            <el-form-item label="开始时间:" >
              <span class="disR">
                <span>购票</span>
                <el-input v-model="ruleForm.Hour"></el-input>
                <span>小时后</span>
              </span>
            </el-form-item>
          </div>
          <div class="disW"  >
            <el-form-item label="消费日期:" v-if="ruleForm.ConsumeState=='1'">
              <!-- <span class="posiA">*</span> -->
              <el-date-picker
                disabled
                v-model="ConsumeTime"
                type="datetimerange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="消费截止日期:"  v-if="ruleForm.ConsumeState=='2'" >
                <div class="conendTime">
                  <el-date-picker
                  v-model="endtimes"
                  type="datetime"
                  disabled
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
                </div>
              </el-form-item>
          </div>
          <el-form-item  v-if="ruleForm.type=='0'">
            <div class="disX">
              <!-- <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
              >每日</el-checkbox> -->
              <el-checkbox disabled v-model="checkAll" @change="yesChange">可使用星期</el-checkbox>
              <div style="margin: 15px 0;"></div>
              <el-checkbox-group disabled v-model="checkedCities" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="disN">
              <el-checkbox disabled v-model="ruleForm.timeflag">可用时间</el-checkbox>
              <el-time-picker
                is-range
                disabled 
                v-model="flagtime"
                range-separator="至"
                value-format="HH:mm"
                format="HH:mm"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围"
              ></el-time-picker>
              <span>(24小时制)</span>
            </div>
          </el-form-item>
          <div class="disL" v-if="ruleForm.type=='1'">
            <el-form-item label="日库存:">
              <!-- <span class="posiL">*</span> -->
              <el-input disabled v-model="ruleForm.NumBerflag"></el-input>
            </el-form-item>
            <span>0为不限制数量</span>
          </div>
          <div class="disK" v-if="ruleForm.type==1">
            <el-form-item label="产品日历设置:">
              <!-- <span class="posiC">*</span> -->
              <el-button  @click="dataSetFn()">产品日历详情设置</el-button>
            </el-form-item>
          </div>

          <div class="disK" v-if="ruleForm.type=='0'">
            <el-form-item label="每日数量限制:" prop="NumBerflag">
              <!-- <span class="posiC">*</span> -->
              <el-input  disabled v-model="ruleForm.NumBerflag"></el-input>
            </el-form-item>
            <span>0为不限制数量</span>
            <el-form-item label="总量限制:" prop="Number">
              <!-- <span class="posiA">*</span> -->
              <el-input disabled v-model="ruleForm.Number"></el-input>
            </el-form-item>
            <span>0为不限制数量</span>
          </div>
          <div class="disK" v-if="ruleForm.type=='0'">
            <el-form-item label="每日预定数量限制:" prop="ReserveNumBerflag">
              <!-- <span class="posiV">*</span> -->
              <el-input disabled v-model="ruleForm.ReserveNumBerflag"></el-input>
            </el-form-item>
            <span>0为不限制数量</span>
            <el-form-item label="预定总量限制:" prop="ReserveNumber">
              <!-- <span class="posiC">*</span> -->
              <el-input disabled v-model="ruleForm.ReserveNumber"></el-input>
            </el-form-item>
            <span>0为不限制数量</span>
          </div>
          <div class="disK">
            <el-form-item label="提前下单:">
              <el-input v-model="ruleForm.preday"></el-input>
              <span style="margin:0 10px;">天</span>
              <el-time-picker disabled v-model="ruleForm.pretime" placeholder="任意时间点" value-format="HH:mm" format="HH:mm"></el-time-picker>
              <span>前下单</span>
            </el-form-item>
          </div>
          <el-form-item label="状态:">
            <!-- <span class="posiZ">*</span> -->
            <el-radio-group disabled v-model="ruleForm.UseFlag">
              <el-radio label="0">上线</el-radio>
              <el-radio label="1">下线</el-radio>
            </el-radio-group>
            <span class="spanA">
              <span>注:</span>
              <span>默认为允许销售,下线则不允许销售</span>
            </span>
          </el-form-item>
          <el-form-item label="是否同步到订单:" v-if="titleType!='添加产品'">
            <el-radio-group disabled v-model="ruleForm.orderflag">
              <el-radio label="0">不同步到订单</el-radio>
              <el-radio label="1">同步到订单</el-radio>
            </el-radio-group>
            <span class="spanA">
              <span>注:</span>
              <span>同步到订单，会把未使用的订单信息修改，慎用！！！</span>
            </span>
          </el-form-item>
          <el-form-item >
            <div class="btn">
              <!-- <el-button @click="resetForm()">清空</el-button> -->
              <!-- <el-button class="btnL" @click="submitForm('ruleForms')">确认保存</el-button> -->
            </div>
          </el-form-item>
        </el-form>
      </div>
      </el-dialog>
    </div>
    <!-- 添加产品弹框结束 -->
    <!-- 产品日历设置开始 -->

    <div >
      <el-dialog :close-on-click-modal="false"
        title="产品日历设置"
        :visible.sync="dataDialogVisible"
        :before-close="dataHandleClose"
        width="80%"
        center
      >
        <el-divider></el-divider>
        <!-- v-if="dataType==1" -->
        <div class="dataForm" >
          <el-form ref="dataForm" :model="ruleForms" label-width="100px" :rules="ruleFormsRules">
            <el-form-item label="产品日历:">
              <el-radio-group disabled v-model="ruleForms.radio" @change="radioFn">
                <el-radio label="1">批量设置</el-radio>
                <el-radio label="2">指定日期设置</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="销售日期:" prop="ProductTime" v-if="ruleForms.radio=='1'">
              <el-date-picker
              disabled
                v-model="ProductTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <el-form-item prop="week" v-if="ruleForms.radio=='1'">
              <div class="disX">
                <el-checkbox
                disabled
                  :indeterminate="isIndeterminate"
                  v-model="checkAlls"
                  @change="handleCheckAllChange"
                >每日</el-checkbox>
                <div style="margin: 15px 0;"></div>
                <el-checkbox-group v-model="ruleForms.week" @change="handleCheckedChanges">
                  <el-checkbox v-for="city in weeks" :label="city" :key="city">{{city}}</el-checkbox>
                </el-checkbox-group>
              </div>
            </el-form-item>
            <el-form-item label="状态:" v-if="ruleForms.radio=='1'">
              <el-radio-group disabled v-model="ruleForms.status">
                <el-radio label="1">售卖</el-radio>
                <el-radio label="2">停售</el-radio>
              </el-radio-group>
            </el-form-item>
            <div class="dataDis" v-if="ruleForms.radio=='1'">
              <el-form-item label="门市价:" prop="price">
                <el-input disabled placeholder="请输入门市价" v-model="ruleForms.price" clearable></el-input>
              </el-form-item>
              <span>元</span>
            </div>
            <div class="dataDis" v-if="ruleForms.radio=='1'">
              <el-form-item label="销售价:" prop="sellprice">
                <el-input disabled placeholder="请输入销售价" v-model="ruleForms.sellprice" clearable></el-input>
              </el-form-item>
              <span>元</span>
            </div>
            <div class="dataDis" v-if="ruleForms.radio=='1'">
              <el-form-item label="代理价:" prop="agentprice">
                <el-input disabled placeholder="请输入代理价" v-model="ruleForms.agentprice" clearable></el-input>
              </el-form-item>
              <span>元</span>
            </div>
          </el-form>
        </div>
        <div class="btn" v-if="ruleForms.radio==1">
          <el-button>清空</el-button>
          <el-button class="btnL" @click="successBtns('dataForm')">确认</el-button>
        </div>
        <div class="dataZd" v-if="ruleForms.radio=='2'">
          <div class="btnHer">
            <div class="her" @click="getPreMonth" >
              上一个月
            </div>
            <div class="her" @click="getGoMonth" >
              下一个月
            </div>
          </div>
          <el-calendar  v-model="value"  v-loading="loading">
              <div slot="dateCell" slot-scope="{date, data}" >
                <p
                  :class="data.isSelected ? 'is-selected' : ''"
                  @click="allcalendar(data)">{{ data.day }} {{ data.isSelected ? '✔️' : ''}}</p>
                <div v-for="(item,index) in dateList" :key="index" v-if="data.day==item.date">
                  <el-form class="itemFome" ref="form"  label-width="80px">
                    <el-form-item label="门市价:">
                      <el-input v-model="item.price" @blur="rate(item)"></el-input>
                    </el-form-item>
                    <el-form-item label="售卖价:">
                      <el-input v-model="item.sellprice" @blur="Selling(item)"></el-input>
                    </el-form-item>
                    <el-form-item label="代理价:">
                      <el-input v-model="item.agentprice" @blur="Agency(item)"></el-input>
                    </el-form-item>
                    <el-form-item label="库存:">
                      <el-input v-model="item.stock" @blur="inventory(item)"></el-input>
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </el-calendar>
        </div>
      </el-dialog>
    </div>
    <!-- 指定日期设置开始 -->

    <!-- <div v-if="radio=='2'">
      <el-dialog :close-on-click-modal="false"
        title="产品日历设置"
        :visible.sync="dataZdDialogVisible"
        :before-close="dataZdHandleClose"
        width="79%"
        center
        top="5vh"
      >
      <el-radio-group v-model="radio" @change="radioFn">
        <el-radio label="1">批量设置</el-radio>
        <el-radio label="2">指定日期设置</el-radio>
      </el-radio-group>
        <el-divider></el-divider>
       
      </el-dialog>
    </div> -->
    <!-- 指定日期设置结束 -->
  </div>
</template>

<script>
import {getProductInfo, getProductSonList ,ScenicProductSonType,AddScenicProduct,SetBatchProduct,UpdateScenicProduct,SetAloneProduct,CldDateList,GetWeek} from '@/request/scenic.js'
import { Message } from "element-ui";
const cityOptions = [
  "星期一",
  "星期二",
  "星期三",
  "星期四",
  "星期五",
  "星期六",
  "星期日"
];
export default {
  props:['typeArr'],
  data() {
    const validatorDate = (rule, value, callback) => {
      return value !== '' ? callback() : callback(new Error(rule.message));
    };
    return {
      DetailFlow:false,
      transDetImgList:[],
      dateList:[],
      ProductID:'',
      ProductTime:'',
      checkAlls:'0',
      labelPosition: "right",
      addProDialogVisible: false, // 添加产品弹框
      dataDialogVisible: false, // 添加产品产品日历设置弹框
      // dataZdDialogVisible: false, // 指定日期弹框
      titleType: "", // 弹框标题名
      // 图片
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      ruleForm: {
        age_range_start:'',
        age_range_end:'',
        product_son:[],
        UsePeopleNum:'1',
        radio:'',//完善身份证信息
        radio1:'1',//身份证刷门禁进入
        token:window.sessionStorage.getItem('Token'),
        ProductType:'',// 类型
        ProductName:"",// 产品名称
        description:'',//	简介
        type:'0',//产品模式
        ValidStatus:'2', // 销售有效期状态码
        ValidBeginDate:'', //销售有效期开始日期
        ValidEndDate:'', //销售有效期结束日期
        ConsumeState:'1', //消费日期状态
        ConsumeBeginDate:'', // 消费有效期开始日期
        ConsumeEndDate:'',// 消费有效期结束日期
        Hour:'',//生效时间
        weekflag:'', // 可使用星期状态
        weeks:'',//可使用星期
        timeflag:'', //可使用时间状态
        usebegintime:'', // 使用时间开始时间
        useendtime:'', // 使用时间结束时间
        preday:'',//	提前几天下单
        Price:'',// 门市价
        SellPrice:'',//	建议销售价
        AgentPrice:'', //分销商代理价
        Deposit:'',//押金
        ReturnFlag:'0',//退款
        NumBerflag:'',//每日数量限制
        Number:'',//总数量限制
        ReserveNumBerflag:'',//每日预定数量限制
        ReserveNumber:'',//预定总限制
        WebPic:'',//互联网产品图片地址
        Memo:'\t\t\t\t\t\t<p>【使用人群】：</p>\r\n\t\t\t\t\t\t\t<p>【预定时间】：</p>\r\n\t\t\t\t\t\t\t<p>【有效期】：</p>\r\n\t\t\t\t\t\t\t<p>【费用包含】：</p>\r\n\t\t\t\t\t\t\t<p>【适用条件】：</p>\r\n\t\t\t\t\t\t\t<p>【取票方式】：</p>\r\n\t\t\t\t\t\t\t<p>【其他须知】：</p>\r\n\t\t\t\t\t\t\t<p>【联系电话】：</p>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<p><br></p>', // 产品描述
        pretime:'',// 在几点前下单
        openTime:'',
        closeTime:'',
        minimumTime:'',
        place:'',
        UseFlag:'0',
        Invoice:'',
        image1:'',
        image2:'',
        image3:'',
        image4:'',
        image5:'',
        orderflag:'',
        limit_buy:''
      },
      rules: {
        ProductName: [
          { required: true, message: "请输入产品名称", trigger: "blur" },
        ],
        ProductType: [
          { required: true, message: "请选择产品分类", trigger: "change" }
        ],
        type: [
          { required: true, message: "请选择产品模式", trigger: "change" }
        ],
        ConsumeState: [
          { required: true, message: "请选择消费日期状态", trigger: "change" }
        ],
        ConsumeEndDate:[
          { required: true, message: "请选择销售有效期", trigger: "change" }
        ],
        Invoice:[
          { required: true, message: "请输入发票开具说明", trigger: "blur" },
        ],
        NumBerflag:[
          { required: true, message: "请输入每日数量限制", trigger: "blur" },
        ],
        ReserveNumBerflag:[
          { required: true, message: "请输入每日预定数量限制", trigger: "blur" },
        ],
        ReserveNumber:[
          { required: true, message: "请输入预定总限制", trigger: "blur" },
        ],
        Number:[
          { required: true, message: "请输入总数量限制", trigger: "blur" },
        ],
        Price:[
        { required: true, message: "请输入门市价", trigger: "blur" },
        ],
        SellPrice:[
          { required: true, message: "请输入建议销售价", trigger: "blur" },
        ],
        AgentPrice:[
          { required: true, message: "请输入代理价", trigger: "blur" },
        ],
        Deposit:[
          { required: true, message: "请输入押金金额", trigger: "blur" },
        ],
      },
      ruleForms:{
        radio:'1',
        start_date:'',
        end_date:'',
        week:[],
        status:'1',
        price:'',
        sellprice:'',
        agentprice:''
      },
      ruleFormsRules:{
        price: [
          { required: true, message: "请输入门市价", trigger: "blur" },
        ],
        sellprice: [
          { required: true, message: "请输入销售价", trigger: "blur" },
        ],
        agentprice: [
          { required: true, message: "请输入代理价", trigger: "blur" },
        ],
        week: [
          { required: true, message: "请选择星期", trigger: "change" }
        ],
        ProductTime: [
        { required: true, message: '日期是必填字段', validator: validatorDate }
        ],
      },
      radio: "1",
      input: "",
      radioType: "", // 产品日历类别
      dataType: "", // 日历类别弹框
      checkAll: '0',
      checkedCities: [],
      cities: cityOptions,
      weeks:cityOptions,
      isIndeterminate: true,
      value1: '',
      ValidTime:'', //销售有效期 开始结束时间 
      ConsumeTime:'', //消费有效期 开始结束时间 
      flagtime:'',
      options:[
        {
          value:1,
          label:'全场'
        },
        {
          value:2,
          label:'半场'
        }
      ],
      datas:{
        token:window.sessionStorage.getItem('Token')
      },
      fileList:'',
      cldkey:'',
      loading:true,
      yesChangeFlow:false,
      hideUpload:false,
      value:new Date(),
      son:[
        {
          productname_son:'',
          son_number:'',
          price_son:'',
          // type_son:'',
          product_son_id:''
        }
      ],
      sonOption:[],
      endtimes:""
    };
  },
  created(){
    this.yesChangeFlow=false
    let data = {
      token:window.sessionStorage.getItem('Token')
    }
    ScenicProductSonType(data).then(res=>{
      if(res.data.status=='ok'){
        this.sonOption = res.data.result
      }
    })
  },
  methods: {
    // 第一天
    getStartTime(e) {
        let date = new Date(e)
        date.setDate(1) // 将当前时间的日期设置成第一天
        let year= date.getFullYear()  // 得到当前年份 
        let month = date.getMonth()  + 1 // 得到当前月份（0-11月份，+1是当前月份）
        month  = month > 10 ? month :'0' + month // 补零
        let day  = date.getDate() // 得到当前天数，实际是本月第一天，因为前面setDate(1) 设置过了
        return  (day<10?'0'+day:day)// 这里传入的是字符串
    },
    // 最后一天
    getEndTime(e){
      let  date  = new Date(e)
      let year = date.getFullYear()  
      let month = date.getMonth() +1
    // 这里传入的是整数时间，返回的是下个月的第一天，因为月份是0-11
      let nextMonthFirthDay = new Date(year,month,1) // 下个月的第一天
      let oneDay = 1000*60 * 60 * 24 // 一天的时间毫秒数
      let endDay = new Date(nextMonthFirthDay - oneDay) 
      let day = endDay.getDate() // 本月最后一天
      // 这里传入的是字符串格式的时间，返回的是传入字符串的时间
      return (day<10?'0'+day:day)
    },
    getTime(date){
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      let d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      let h =date.getHours()
      h = h < 10 ? ('0' + h) : h
      let M =date.getMinutes()
      M = M < 10 ? ('0' + M) : M
      let s =date.getSeconds()
      s = s < 10 ? ('0' + s) : s
      return y + '-' + m + '-' + d 
      // + ' ' + h + ':' + M + ':' + s;
    },
    // 点击获取上个月
    getPreMonth() {
      this.dateList = []
      let date = this.getTime(this.value)
      var arr = date.split('-');
      var year = arr[0]; //获取当前日期的年份
      var month = arr[1]; //获取当前日期的月份
      var day = arr[2]; //获取当前日期的日
      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中月的天数
      var year2 = year;
      var month2 = parseInt(month) - 1;
      if (month2 == 0) {
          year2 = parseInt(year2) - 1;
          month2 = 12;
      }
      var day2 = day;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
          day2 = days2;
      }
      if (month2 < 10) {
          month2 = '0' + month2;
      }
      var t2 = year2 + '-' + month2 + '-' + day2;
      this.allcalendar(t2)
      this.value = new Date(t2)
    },
    getGoMonth(){
      this.dateList = []
      let date = this.getTime(this.value)
      var arr = date.split('-');
      var year = arr[0]; //获取当前日期的年份
      var month = arr[1]; //获取当前日期的月份
      var day = arr[2]; //获取当前日期的日
      var days = new Date(year, month, 0);
      days = days.getDate(); //获取当前日期中的月的天数
      var year2 = year;
      var month2 = parseInt(month) + 1;
      if (month2 == 13) {
          year2 = parseInt(year2) + 1;
          month2 = 1;
      }
      var day2 = day;
      var days2 = new Date(year2, month2, 0);
      days2 = days2.getDate();
      if (day2 > days2) {
          day2 = days2;
      }
      if (month2 < 10) {
          month2 = '0' + month2;
      }
      var t2 = year2 + '-' + month2 + '-' + day2;
      this.allcalendar(t2)
      this.value = new Date(t2)
    },
     // 第一天
     getStartTime1(e) {
        let date = new Date(e)
        date.setDate(1) // 将当前时间的日期设置成第一天
        let year= date.getFullYear()  // 得到当前年份 
        let month = date.getMonth()  + 1 // 得到当前月份（0-11月份，+1是当前月份）
        month  = month > 10 ? month :'0' + month // 补零
        let day  = date.getDate() // 得到当前天数，实际是本月第一天，因为前面setDate(1) 设置过了
        return  (day<10?'0'+day:day)// 这里传入的是字符串
    },
    // 最后一天
    getEndTime1(e){
      let  date  = new Date(e)
      let year = date.getFullYear()  
      let month = date.getMonth() +1
    // 这里传入的是整数时间，返回的是下个月的第一天，因为月份是0-11
      let nextMonthFirthDay = new Date(year,month,1) // 下个月的第一天
      let oneDay = 1000*60 * 60 * 24 // 一天的时间毫秒数
      let endDay = new Date(nextMonthFirthDay - oneDay) 
      let day = endDay.getDate() // 本月最后一天
      // 这里传入的是字符串格式的时间，返回的是传入字符串的时间
      return (day<10?'0'+day:day)
    },
    allcalendar(e){
      var date = new Date(e);
      let firstDay =  this.getStartTime(e)
      let lastDay = this.getEndTime(e)
      var year = date.getFullYear(); // 年
      var month = date.getMonth() + 1; // 月
      var first = year + '-' + month + '-' + firstDay  + ' 00:00:00'
      var last = year + '-' + month + '-' + lastDay   + ' 23:59:59'
      let data = {
        token:window.sessionStorage.getItem('Token'),
        goods_id:this.ProductID,
        startTime:first,
        endTime:last
      }
      CldDateList(data).then(res=>{
        if(res.data.rcode==200){
          this.dateList =  res.data.result
          this.dateList.map(item=>{
            item.stock = item.daynumber
          })
          this.loading = false
        }else{
          this.loading = false
          Message.error('当前无数据')
        }
      })
    },
    yesChange(e){
      if(this.yesChangeFlow==false){
        this.$nextTick(function(){
          this.checkAll = true
          this.checkedCities = ['星期一', '星期二','星期三', '星期四','星期五', '星期六','星期日']
          this.yesChangeFlow=true
        })
      }
      if(e){
        this.checkedCities = ['星期一', '星期二','星期三', '星期四','星期五', '星期六','星期日']
      }else{
        this.checkedCities = []
      }
    },
    rate(item){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        day:item.date,
        price:item.price,
        sellprice:item.sellprice,
        agentprice:item.agentprice,
        stock:item.stock,
        stype:'1'
      }
      SetAloneProduct(data).then(res=>{
        if(res.data.rcode==200){
                this.cldkey = res.data.result
                Message({
                    type: "success",
                    message: "日历设置成功"
               })
         
        }
      })
    },
    Selling(item){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        day:item.date,
        price:item.price,
        sellprice:item.sellprice,
        agentprice:item.agentprice,
        stock:item.stock,
        stype:'1'
      }
      SetAloneProduct(data).then(res=>{
        if(res.data.rcode==200){
          this.cldkey = res.data.result
          Message({
              type: "success",
              message: "日历设置成功"
          })
        }
      })
    },
    Agency(item){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        day:item.date,
        price:item.price,
        sellprice:item.sellprice,
        agentprice:item.agentprice,
        stock:item.stock,
        stype:'1'
      }
      SetAloneProduct(data).then(res=>{
        if(res.data.rcode==200){
                this.cldkey = res.data.result
                Message({
                    type: "success",
                    message: "日历设置成功"
               })
         
        }
      })
    },
    inventory(item){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        day:item.date,
        price:item.price,
        sellprice:item.sellprice,
        agentprice:item.agentprice,
        stock:item.stock,
        stype:'1'
      }
      SetAloneProduct(data).then(res=>{
        if(res.data.rcode==200){
                this.cldkey = res.data.result
                Message({
                    type: "success",
                    message: "日历设置成功"
               })
         
        }
      })
    },
    // 日历批量设置
    successBtns(dataForm){
      this.$refs[dataForm].validate((valid)=>{
        if(valid){
           var arr = []
          if(this.ruleForms.week.length!=0){
            this.ruleForms.week.map(item=>{
              switch(item){
                case '星期一':
                arr.push('1')
                    break;
                case '星期二':
                arr.push('2')
                    break;
                case '星期三':
                arr.push('3')
                    break;
                case '星期四':
                arr.push('4')
                    break;
                case '星期五':
                arr.push('5')
                    break;
                case '星期六':
                arr.push('6')
                    break;
                case '星期日':
                arr.push('7')
                    break;
                default:
                    break;
              }
            })
          }
          let data = {
            token:window.sessionStorage.getItem('Token'),
            start_date:this.ProductTime[0],
            end_date:this.ProductTime[1],
            week:arr,
            status:this.ruleForms.status,
            price:this.ruleForms.price,
            sellprice:this.ruleForms.sellprice,
            agentprice:this.ruleForms.agentprice
          }
          SetBatchProduct(data).then(res=>{
              if(res.data.rcode==200){
                this.cldkey = res.data.result
                Message({
                    type: "success",
                    message: "日历设置成功"
                })
                this.dataDialogVisible = false;
                this.ruleForm.Price = this.ruleForms.price
                this.ruleForm.SellPrice=this.ruleForms.sellprice,
                this.ruleForm.AgentPrice=this.ruleForms.agentprice
              }
            })
        }else{

        }
      })
    },
    getDetail(row){
      this.ProductID = row.productid
      let data = {
        token:window.sessionStorage.getItem('Token'),
        ProductID:row.productid
      }
      getProductInfo(data).then(res=>{
        if(res.data.status=='ok'){
          this.cldkey = res.data.result.cldkey
          res.data.result.orderflag = 0 + ''
          this.ruleForm = res.data.result
          this.ruleForm.Invoice = res.data.result.invoice_instructions
          this.ruleForm.ReturnFlag = res.data.result.ReturnFlag + ''
          this.ruleForm.type = res.data.result.type + ''
          this.ruleForm.ValidStatus = res.data.result.ValidStatus+''
          this.ruleForm.ConsumeState = res.data.result.ConsumeState + ''
          this.ruleForm.timeflag = res.data.result.timeflag=='1'?true:false
          this.ruleForm.UseFlag = res.data.result.UseFlag + ''
          this.checkAll = res.data.result.weekflag=='1'?true:false
          this.ruleForm.radio = res.data.result.IDCard + ''
          this.ruleForm.radio1 = res.data.result.card_access + ''
          this.ConsumeTime = [res.data.result.ConsumeBeginDate,res.data.result.ConsumeEndDate]
          this.endtimes = res.data.result.ConsumeEndDate
          this.ValidTime = [res.data.result.ValidBeginDate,res.data.result.ValidEndDate]
          this.flagtime = [res.data.result.usebegintime,res.data.result.useendtime]
          this.ruleForm.openTime = res.data.result.openTime
          this.dialogImageUrl = res.data.result.WebPic
          this.ruleForm.age_range_start = res.data.result.age_range_start
          this.ruleForm.age_range_end = res.data.result.age_range_end
          this.ruleForm.limit_buy = res.data.result.limit_buy?res.data.result.limit_buy:0
          if(res.data.result.weeks.length!=0){
            this.ruleForm.weeks = JSON.parse(res.data.result.weeks)
            this.ruleForm.weeks.map(item=>{
              switch (item) {
                    case '7':
                        this.checkedCities.push('星期日')
                        break;
                    case '6':
                        this.checkedCities.push('星期六')
                        break;
                    case '5':
                        this.checkedCities.push('星期五')
                        break;
                    case '4':
                        this.checkedCities.push('星期四')
                        break;
                    case '3':
                        this.checkedCities.push('星期三')
                        break;
                    case '2':
                        this.checkedCities.push('星期二')
                        break;
                    case '1':
                        this.checkedCities.push('星期一')
                        break;
                   default:
              }
            })
            if(this.ruleForm.weeks.length=='7'){
              this.checkAll = true
            }
          }
          if(res.data.result.ProductType!=20){
            this.son = [
              {
                productname_son:'',
                son_number:'',
                price_son:'',
                // type_son:''
              }
            ]
          }else{
            let data = {
              token:window.sessionStorage.getItem('Token'),
            }
            getProductSonList(data).then(ress=>{
              if(ress.data.status=='ok'){
                this.tableDataName = ress.data.result
              }
            })
            this.son = res.data.result.product_son
          }
          this.$forceUpdate()
          let img = []
          if(this.ruleForm.image1){
            img.push({
              url:this.ruleForm.image1
            })
          }
          if(this.ruleForm.image2){
            img.push({
              url:this.ruleForm.image2
            })
          }
          if(this.ruleForm.image3){
            img.push({
              url:this.ruleForm.image3
            })
          }
          if(this.ruleForm.image4){
            img.push({
              url:this.ruleForm.image4
            })
          }
          if(this.ruleForm.image5){
            img.push({
              url:this.ruleForm.image5
            })
          }
          this.transDetImgList = img;
        }
      })
    },
    // 单选框日历
    radioFn(e) {
      if(e==2){
          if(this.ProductID){
            var date = new Date();
            date.setDate(1);
            var firstDay = date.toLocaleDateString().replace(/\//g,"-");
            date.setMonth(date.getMonth() + 1);
            date.setDate(0);
            var lastDay = date.toLocaleDateString().replace(/\//g,"-");
            let data = {
              token:window.sessionStorage.getItem('Token'),
              goods_id:this.ProductID,
              startTime:firstDay,
              endTime:lastDay 
            }
            CldDateList(data).then(res=>{
              if(res.data.rcode==200){
                this.dateList =  res.data.result
                this.dateList.map(item=>{
                  item.stock = item.daynumber
                })
                this.loading = false
              }else{
                this.loading = false
                Message.error('当前无数据')
              }
            })
          }
      }
    },
    // 点击产品日历
    dataSetFn() {
      if(this.ValidTime){
        this.ProductTime = this.ValidTime
        this.getEveryDay(this.ValidTime[0],this.ValidTime[1])
        this.dataDialogVisible = true;
        if(this.ProductID){
          let data = {
            ProductId:this.ProductID,
            token:window.sessionStorage.getItem('Token')
          }
          GetWeek(data).then(res=>{
            if(res.data.rcode==200){
              this.ruleForms.status = res.data.result.status + ''
              // this.ruleForms.week  = res.data.result.week
              if(res.data.result.week){
                let week = res.data.result.week.split(',')
                week.map(item=>{
                  switch (item) {
                        case '7':
                           this.ruleForms.week.push('星期日')
                            break;
                        case '6':
                            this.checkedCities.push('星期六')
                            break;
                        case '5':
                            this.ruleForms.week.push('星期五')
                            break;
                        case '4':
                            this.ruleForms.week.push('星期四')
                            break;
                        case '3':
                            this.ruleForms.week.push('星期三')
                            break;
                        case '2':
                            this.ruleForms.week.push('星期二')
                            break;
                        case '1':
                            this.ruleForms.week.push('星期一')
                            break;
                      default:
                          
                  }
                })
              }
              this.ruleForms.price =res.data.result.price
              this.ruleForms.sellprice =res.data.result.sellprice
              this.ruleForms.agentprice = res.data.result.agentprice
            }
          })
        }
      }else{
        Message.error('请设置销售日期')
      }
      // // if (this.dataType == 1) {
      // // this.dataZdDialogVisible = true;
      // // }
    },
    getEveryDay(start, end) {
        var start = start;
        var end = end;
        var startTime = this.getDate(start);
        var endTime = this.getDate(end);
        this.dateList = [];
        while ((endTime.getTime() - startTime.getTime()) >= 0) {
          var year = startTime.getFullYear();
          var month = startTime.getMonth().toString().length == 1 ? "0" + startTime.getMonth().toString() : startTime.getMonth();
          var day = startTime.getDate().toString().length == 1 ? "0" + startTime.getDate() : startTime.getDate();
          this.dateList.push({
            date: year + "-" + month + "-" + day,
            price: "",
            sellprice:'',
            agentprice:'',
            stock:'',
          });
          startTime.setDate(startTime.getDate() + 1);
        }
      },
      getDate(datestr) {
        var temp = datestr.split("-");
        var date = new Date(temp[0], temp[1], temp[2]);
        return date;
      },
    // 点击产品日历指定日期X
    // dataZdHandleClose() {
    //   this.dataZdDialogVisible = false;
    // },
    // 点击产品日历X
    dataHandleClose() {
      this.dataDialogVisible = false;
      this.ruleForms.radio = '1'
    },
    submitForm(ruleForms) {
      if(this.ProductID){
          var arr = []
          if(this.checkedCities.length!=0){
            this.checkedCities.map(item=>{
              switch(item){
                case '星期一':
                arr.push('1')
                    break;
                case '星期二':
                arr.push('2')
                    break;
                case '星期三':
                arr.push('3')
                    break;
                case '星期四':
                arr.push('4')
                    break;
                case '星期五':
                arr.push('5')
                    break;
                case '星期六':
                arr.push('6')
                    break;
                case '星期日':
                arr.push('7')
                    break;
                default:
                    break;
              }
            })
          }
          this.$refs[ruleForms].validate((valid) => {
          if (valid) {
            if(this.ruleForm.type=='1'){
              this.ruleForm.ConsumeState='1'
            }
            let data  = {
              token:window.sessionStorage.getItem('Token'),
              ProductType:this.ruleForm.ProductType, // 产品类型1
              ProductName:this.ruleForm.ProductName, // 	产品名称1
              description:this.ruleForm.description, // 简介
              type:this.ruleForm.type,  //产品模式1
              ValidStatus:this.ruleForm.ValidStatus,//销售有效期状态码
              ValidBeginDate:this.ruleForm.ValidStatus=='1'?'':this.ValidTime[0],//销售有效期开始日期
              ValidEndDate:this.ruleForm.ValidStatus=='1'?'':this.ValidTime[1], //销售有效期结束日期
              ConsumeState:this.ruleForm.ConsumeState, //消费日期状态1
              ConsumeBeginDate:this.ruleForm.ConsumeState=='1'?this.ConsumeTime[0]:this.ConsumeTime[0],//消费有效期开始日期
              ConsumeEndDate:this.ruleForm.ConsumeState=='1'?this.ConsumeTime[1]:this.ConsumeTime[1],//消费有效期结束日期1
              Hour:this.ruleForm.ConsumeState=='2'?this.ruleForm.Hour:'', //生效时间1
              weekflag:this.checkAll==true?'1':'0',//可使用星期状态1
              weeks:this.checkAll==true?arr:'',//可使用星期
              timeflag:this.ruleForm.timeflag==true?'1':'0',//可使用时间状态
              usebegintime:this.ruleForm.timeflag==true?this.flagtime[0]:'0',//使用时间开始时间
              useendtime:this.ruleForm.timeflag==true?this.flagtime[1]:'0',//使用时间结束时间
              preday:this.ruleForm.preday,//提前几天下单
              Price:this.ruleForm.Price,//门市价
              SellPrice:this.ruleForm.SellPrice,//建议销售价
              AgentPrice:this.ruleForm.AgentPrice,//分销商代理价
              Deposit:this.ruleForm.Deposit,//押金
              ReturnFlag:this.ruleForm.ReturnFlag,//退款
              NumBerflag:this.ruleForm.NumBerflag,//每日数量限制
              Number:this.ruleForm.Number,//总数量限制
              ReserveNumBerflag:this.ruleForm.ReserveNumBerflag,//每日预定数量限制
              ReserveNumber:this.ruleForm.ReserveNumber,//预定总限制
              WebPic:this.ruleForm.WebPic,//互联网产品图片地址
              Memo:this.ruleForm.Memo,//产品描述
              openTime:this.ruleForm.ProductType=='3'?this.ruleForm.openTime:'',//	场馆开始时间
              closeTime:this.ruleForm.ProductType=='3'?this.ruleForm.closeTime:'',//场馆结束时间
              minimumTime:this.ruleForm.ProductType=='3'?this.ruleForm.minimumTime:'',//最少起订时间
              place:this.ruleForm.ProductType=='3'?this.ruleForm.place:'',//场地类型
              serialNumber:this.ruleForm.ProductType=='3'?this.ruleForm.serialNumber:'',//场地编码
              UseFlag:this.ruleForm.UseFlag,//上线状态
              Invoice:this.ruleForm.Invoice,//发票
              image1:this.ruleForm.image1,
              image2:this.ruleForm.image2,
              image3:this.ruleForm.image3,
              image4:this.ruleForm.image4,
              image5:this.ruleForm.image5,
              IDCard:this.ruleForm.radio,
              card_access:this.ruleForm.radio1,
              UsePeopleNum:'1',
              cldkey:this.cldkey,
              pretime:this.ruleForm.pretime,
              ProductID:this.ProductID,
              orderflag:this.ruleForm.orderflag,
              limit_buy:this.ruleForm.limit_buy
            }
            UpdateScenicProduct(data).then(res=>{
              if(res.data.rcode==200){
                Message.success('修改成功')
                this.addProDialogVisible = false
                this.$emit('ProClose')
              }else{
                Message.error(res.data.msg)
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }else{
        var arr = []
        if(this.checkedCities.length!=0){
          this.checkedCities.map(item=>{
            switch(item){
              case '星期一':
              arr.push('1')
                  break;
              case '星期二':
              arr.push('2')
                  break;
              case '星期三':
              arr.push('3')
                  break;
              case '星期四':
              arr.push('4')
                  break;
              case '星期五':
              arr.push('5')
                  break;
              case '星期六':
              arr.push('6')
                  break;
              case '星期日':
              arr.push('7')
                  break;
              default:
                  break;
            }
          })
        }
        this.$refs[ruleForms].validate((valid) => {
            if (valid) {
              let data  = {
                token:window.sessionStorage.getItem('Token'),
                ProductType:this.ruleForm.ProductType, // 产品类型1
                ProductName:this.ruleForm.ProductName, // 	产品名称1
                description:this.ruleForm.description, // 简介
                type:this.ruleForm.type,  //产品模式1
                ValidStatus:this.ruleForm.ValidStatus,//销售有效期状态码
                ValidBeginDate:this.ruleForm.ValidStatus=='1'?'':this.ValidTime[0],//销售有效期开始日期
                ValidEndDate:this.ruleForm.ValidStatus=='1'?'':this.ValidTime[0], //销售有效期结束日期
                ConsumeState:this.ruleForm.ConsumeState, //消费日期状态1
                ConsumeBeginDate:this.ruleForm.ConsumeState=='1'?this.ConsumeTime[0]:'',//消费有效期开始日期
                ConsumeEndDate:this.ruleForm.ConsumeState=='1'?this.ConsumeTime[1]:this.ruleForm.ConsumeEndDate,//消费有效期结束日期1
                Hour:this.ruleForm.ConsumeState=='2'?this.ruleForm.Hour:'', //生效时间1
                weekflag:this.checkAll==true?'1':'0',//可使用星期状态1
                weeks:this.checkAll==true?arr:'',//可使用星期
                timeflag:this.ruleForm.timeflag==true?'1':'0',//可使用时间状态
                usebegintime:this.ruleForm.timeflag==true?this.flagtime[0]:'0',//使用时间开始时间
                useendtime:this.ruleForm.timeflag==true?this.flagtime[1]:'0',//使用时间结束时间
                preday:this.ruleForm.preday,//提前几天下单
                Price:this.ruleForm.Price,//门市价
                SellPrice:this.ruleForm.SellPrice,//建议销售价
                AgentPrice:this.ruleForm.AgentPrice,//分销商代理价
                Deposit:this.ruleForm.Deposit,//押金
                ReturnFlag:this.ruleForm.ReturnFlag,//退款
                NumBerflag:this.ruleForm.NumBerflag,//每日数量限制
                Number:this.ruleForm.Number,//总数量限制
                ReserveNumBerflag:this.ruleForm.ReserveNumBerflag,//每日预定数量限制
                ReserveNumber:this.ruleForm.ReserveNumber,//预定总限制
                WebPic:this.ruleForm.WebPic,//互联网产品图片地址
                Memo:this.ruleForm.Memo,//产品描述
                openTime:this.ruleForm.ProductType=='3'?this.ruleForm.openTime:'',//	场馆开始时间
                closeTime:this.ruleForm.ProductType=='3'?this.ruleForm.closeTime:'',//场馆结束时间
                minimumTime:this.ruleForm.ProductType=='3'?this.ruleForm.minimumTime:'',//最少起订时间
                place:this.ruleForm.ProductType=='3'?this.ruleForm.place:'',//场地类型
                serialNumber:this.ruleForm.ProductType=='3'?this.ruleForm.serialNumber:'',//场地编码
                UseFlag:this.ruleForm.UseFlag,//上线状态
                Invoice:this.ruleForm.Invoice,//发票
                image1:this.ruleForm.image1,
                image2:this.ruleForm.image2,
                image3:this.ruleForm.image3,
                image4:this.ruleForm.image4,
                image5:this.ruleForm.image5,
                IDCard:this.ruleForm.radio,
                card_access:this.ruleForm.radio1,
                UsePeopleNum:'1',
                cldkey:this.cldkey,
                pretime:this.ruleForm.pretime,
                limit_buy:this.ruleForm.limit_buy
              }
              AddScenicProduct(data).then(res=>{
                if(res.data.rcode==200){
                  Message.success('添加成功')
                  this.addProDialogVisible = false
                  this.$emit('ProClose')
                }else{
                  Message.error(res.data.msg)
                }
              })
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        }
    },
    resetForm() {},
    handleRemove(file) {
      if(this.transDetImgList.length!=0){
        this.transDetImgList.map((item,index)=>{
          if(item.url==file.url){
            switch(index){
              case 0:
                this.ruleForm.image1 = ''
                  break;
                case 1:
                this.ruleForm.image2 = ''
                    break;
                case 2:
                this.ruleForm.image3 = ''
                    break;
                case 3:
                this.ruleForm.image4 = ''
                    break;
                case 4:
                this.ruleForm.image5 = ''
                  break;
              default:
                  break;
            }
          }
        })
      }
      if(this.fileList.length!=0){
        this.fileList.map((item,index)=>{
          if(item.name==file.name){
              switch(index){
                case 0:
                  this.ruleForm.image1 = ''
                    break;
                  case 1:
                  this.ruleForm.image2 = ''
                      break;
                  case 2:
                  this.ruleForm.image3 = ''
                      break;
                  case 3:
                  this.ruleForm.image4 = ''
                      break;
                  case 4:
                  this.ruleForm.image5 = ''
                    break;
                default:
                    break;
              }
          }
        })
      }
      if(this.transDetImgList.length<5){
        this.hideUpload = false
      }
      this.$refs.pictureUpload.handleRemove(file)
    },
    attachUploadSuccess(response, file, fileList){
      this.fileList = fileList
      switch(fileList.length){
            case 1:
              this.ruleForm.image1 =response.result
                break;
              case 2:
              this.ruleForm.image2 =response.result
                  break;
              case 3:
              this.ruleForm.image3 =response.result
                  break;
              case 4:
              this.ruleForm.image4 =response.result
                  break;
              case 5:
              this.ruleForm.image5 =response.result
                break;
            default:
                break;
      }
      if(this.fileList.length==5){
        this.hideUpload = true
      }
    },
    // handlePictureCardPreview(file) {
    //   this.dialogImageUrl = file.url;
    //   this.dialogVisible = true;
    // },
    // 封面主图
    handleAvatarSuccess(res, file) {
      this.ruleForm.WebPic = res.result
    },
    handleCheckAllChange(val) {
      this.ruleForms.week = val ? cityOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    },
    handleCheckedChanges(value){
      let checkedCount = value.length;
      this.checkAlls = checkedCount === this.weeks.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.weeks.length;
    },
    // 添加产品
    addProFn(row) {
      if (row) {
        // 详情
        this.titleType = "产品详情";
        this.DetailFlow = true
        this.getDetail(row)
      } else {
        // 添加产品
        this.titleType = "添加产品";
        this.ruleForm={
          UsePeopleNum:'1',
          radio:'1',//完善身份证信息
          radio1:'1',//身份证刷门禁进入
          token:window.sessionStorage.getItem('Token'),
          ProductType:'',// 类型
          ProductName:"",// 产品名称
          description:'',//	简介
          type:'0',//产品模式
          ValidStatus:'2', // 销售有效期状态码
          ValidBeginDate:'', //销售有效期开始日期
          ValidEndDate:'', //销售有效期结束日期
          ConsumeState:'1', //消费日期状态
          ConsumeBeginDate:'', // 消费有效期开始日期
          ConsumeEndDate:'',// 消费有效期结束日期
          Hour:'',//生效时间
          weekflag:'', // 可使用星期状态
          weeks:'',//可使用星期
          timeflag:'', //可使用时间状态
          usebegintime:'', // 使用时间开始时间
          useendtime:'', // 使用时间结束时间
          preday:'',//	提前几天下单
          Price:'',// 门市价
          SellPrice:'',//	建议销售价
          AgentPrice:'', //分销商代理价
          Deposit:'',//押金
          ReturnFlag:'0',//退款
          NumBerflag:'',//每日数量限制
          Number:'',//总数量限制
          ReserveNumBerflag:'',//每日预定数量限制
          ReserveNumber:'',//预定总限制
          WebPic:'',//互联网产品图片地址
          Memo:'\t\t\t\t\t\t<p>【使用人群】：</p>\r\n\t\t\t\t\t\t\t<p>【预定时间】：</p>\r\n\t\t\t\t\t\t\t<p>【有效期】：</p>\r\n\t\t\t\t\t\t\t<p>【费用包含】：</p>\r\n\t\t\t\t\t\t\t<p>【适用条件】：</p>\r\n\t\t\t\t\t\t\t<p>【取票方式】：</p>\r\n\t\t\t\t\t\t\t<p>【其他须知】：</p>\r\n\t\t\t\t\t\t\t<p>【联系电话】：</p>\r\n\t\t\t\t\t\t\t\t\t\t\t\t<p><br></p>', // 产品描述
          pretime:'',// 在几点前下单
          openTime:'',
          closeTime:'',
          minimumTime:'',
          place:'',
          UseFlag:'0',
          Invoice:'',
          image1:'',
          image2:'',
          image3:'',
          image4:'',
          image5:'',
          limit_buy:''
        }
      }
      this.addProDialogVisible = true;
    },
    // 添加产品X
    addProHandleClose() {
      this.addProDialogVisible = false;
      this.$emit('addProClose')
    },
    radioUpdate(){
      this.$forceUpdate()
    }
  }
};
</script>

<style lang='less' scoped>
.dataForm {
  .el-form-item {
    position: relative;
  }
  .xingA {
    position: absolute;
    top: 0px;
    left: -80px;
    color: #ff4d4f;
  }
  .xingB {
    position: absolute;
    top: 0px;
    left: -50px;
    color: #ff4d4f;
  }
  .xingC {
    position: absolute;
    top: 0px;
    left: -65px;
    color: #ff4d4f;
  }
  .disX {
    width: 439px;
    height: 80px;
    display: flex;
    // background: red;
    .el-checkbox {
      margin-right: 20px;
    }
  }
  .dataDis {
    display: flex;
    .el-input {
      width: 563px;
    }
    > span {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 40px;
      /* identical to box height */
      color: #666666;
      margin-left: 10px;
    }
  }
}
.pxDialog {
  .el-form-item__label {
    position: relative;
  }
  .posiA {
    position: absolute;
    top: 0px;
    left: -80px;
    color: #ff4d4f;
  }
  .posiB {
    position: absolute;
    top: 0px;
    left: -107px;
    color: #ff4d4f;
  }
  .posiC {
    position: absolute;
    top: 0px;
    left: -107px;
    color: #ff4d4f;
  }
  .posiD {
    position: absolute;
    top: 0px;
    left: -122px;
    color: #ff4d4f;
  }
  .posiE {
    position: absolute;
    top: 0px;
    left: -135px;
    color: #ff4d4f;
  }
  .posiF {
    position: absolute;
    top: 0px;
    left: -67px;
    color: #ff4d4f;
  }
  .posiG {
    position: absolute;
    top: 0px;
    left: -94px;
    color: #ff4d4f;
  }
  .posiL {
    position: absolute;
    top: 0px;
    left: -73px;
    color: #ff4d4f;
  }
  .posiV {
    position: absolute;
    top: 0px;
    left: -135px;
    color: #ff4d4f;
  }
  .posiZ {
    position: absolute;
    top: 0px;
    left: -50px;
    color: #ff4d4f;
  }
  .el-form {
    width: 1000px;
    margin: auto;
  }

  .disK {
    .el-button {
      background: #ffffff;
      border: 1px solid #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height */
      text-align: center;
      color: #246deb;
    }
  }
  .disL {
    display: flex;
    flex-direction: column;
    .el-input {
      width: 630px;
    }
    span {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      // line-height: 40px;
      /* identical to box height */
      // text-align: right;
      color: #ff4d4f;
      margin:10px 0  0 14rem;
    }
  }
  .spanA {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 40px;
    color: #ff4d4f;
    > span:nth-child(1) {
      margin: 0 10px;
    }
  }
  .disK {
    display: flex;
    .el-input {
      width: 178px;
    }
    > span {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 40px;
      /* identical to box height */
      text-align: right;
      color: #ff4d4f;
      margin: 0 2rem 0 10px;
    }
  }

  .disN {
    display: flex;
    align-items: center;
    span {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #ff4d4f;
      margin-left: 10px;
    }
  }
  .disX {
    display: flex;
    // background: red;
    .el-checkbox {
      margin-right: 20px;
    }
  }
  .xfrq {
    .el-date-editor {
      // width: 600px;
    }
  }
  .disW {
    display: flex;
    .inputW {
      .el-date-editor {
        width: 230px;
      }
    }
    .el-input {
      width: 50px;
    }
  }
  .disE {
    display: flex;
    .el-date-editor {
      // width: 490px;
    }
  }
  .disH {
    display: flex;
    .el-input {
      width: 256px;
      margin-right: 10px;
    }
    > span {
      line-height: 40px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: right;
      color: #666666;
      margin-right: 50px;
    }
  }
  .disG {
    display: flex;
    .el-input {
      width: 256px;
      margin-right: 10px;
    }
    > span:nth-child(2) {
      line-height: 40px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: right;
      color: #666666;
      margin-right: 50px;
    }
  }
  .disF {
    display: flex;
    .el-input {
      width: 552px;
    }
    .el-button {
      width: 145px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      /* identical to box height */
      text-align: center;
      color: #246deb;
    }
    > span {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 40px;
      text-align: right;
      color: #666666;
      margin: 0 20px 0 10px;
    }
  }
  .proFm {
    display: flex;
   
  }
  .fpCss {
    .el-textarea {
      width: 740px;
    }
  }
 
  .disB {
    display: flex;
    .el-input {
      width: 80px;
      margin-right: 10px;
    }
    /deep/.el-form-item__content {
      margin: 0 45px;
    }
  }
  .disA {
    display: flex;
    .el-select {
      width: 280px;
      height: 40px;
      margin-right: 50px;
    }
    .el-input {
      width: 256px;
      height: 40px;
      margin-right: 10px;
    }
    .el-date-editor {
      width: 280px;
      height: 40px;
      margin-right: 50px;
    }
  }
  /deep/ .el-form-item__label {
    font-family: OPPOSans;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 40px;
    /* identical to box height */
    text-align: right;
    color: #666;
  }
  .inputA {
    // background: red;
    .el-input {
      width: 740px;
      height: 40px;
    }
  }
}
.btn {
  margin: 20px 0 30px 0;
  display: flex;
  justify-content: center;
  .el-button {
    width: 100px;
    height: 40px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    border: none;
  }
  .btnL {
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #000000;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4ecb73;
  border-color: #4ecb73;
}
/deep/.is-selected {
  color: #1989fa;
}
/deep/.el-calendar-table td.is-selected {
    background-color: none;
}
/deep/thead {
  th {
    margin-right: 10px;
    text-align: center !important;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    color: #ffffff;
    background: #246deb;
    border-radius: 4px 4px 0px 0px;
  }
}
tbody {
  p {
    width: 198px;
    text-align: center;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    color: #000000;
  }
}
/deep/.prev {
  width: 200px;
}
/deep/.el-calendar-table tr td:first-child {
  border: none;
}
/deep/.el-calendar-table td {
  border: none;
}
/deep/.el-calendar-day {
  box-sizing: border-box;
  padding: 10px 0;
  height: 23rem;
  width: 20rem;
  background: #eaf1fd;
  border-top: 3px solid #87aff4;
}
/deep/.el-calendar-table{
  >thead{
    >th:nth-of-type(6){
      background: #4ECB73;
    }
    >th:nth-of-type(7){
      background: #4ECB73;
    }
  }
}

/deep/.el-calendar-table__row{
  >td:nth-of-type(6){
    .el-calendar-day{
      border-top: 3px solid #4ECB73;
      // border-bottom: 3px solid #4ECB73;
    }
  }
  >td:nth-of-type(7){
    .el-calendar-day{
      border-top: 3px solid #4ECB73;
      // border-bottom: 3px solid #4ECB73;
    }
  }
}
.itemFome {
  /deep/.el-input {
    width: 100px;
    height: 30px;
  }
  /deep/.el-input__inner {
    height: 30px;
  }
  /deep/.el-form-item {
    margin-bottom: 0px;
  }
}
/deep/.ant-message{
  z-index: 99999!important;
}
.main_dialog_one /deep/.el-dialog{
  height: 95% !important;
  overflow: auto;
}
.messageClass{
  z-index: 3000 !important;
}
::v-deep .avatar{
  width: 148px;
  height: 148px;
}
::v-deep .avatar-uploader{
  background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 146px;
    height: 146px;
    cursor: pointer;
    line-height: 146px;
    vertical-align: top;
  border-color: #409EFF;
  display: flex;
  align-content: center;
    color: #409EFF;
    justify-content: center;
}
.spanB {
      display: flex;
      align-items: flex-end;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      /* identical to box height */
      color: #ff4d4f;
      margin-bottom: 20px;
      > span:nth-child(1) {
        margin: 0 10px;
      }
    }
/deep/ .el-upload-list__item>div{
  height: 100%;
}

/deep/ .el-dialog{
  min-width: 900px;
}
.hide /deep/ .el-upload--picture-card {
	display: none;
}
/deep/ .width172 .el-upload{
  width: 17.2rem;
  height: 9.6rem;
  line-height: 11.2rem;
}
/deep/ .width172 .el-upload-list__item,/deep/ .width172 .el-upload-list__item div{
  width: 17.2rem;
  height: 9.6rem;
  line-height: 11.2rem;
  vertical-align: baseline;
}
.proFm /deep/ .avatar-uploader{
  width: 23.3rem;
  height: 13.0rem;
}
.proFm /deep/ .avatar-uploader .el-upload,.proFm /deep/ .avatar-uploader .el-upload img{
  vertical-align: baseline;
  width: 100%;
  height: 100%;
}
/deep/ .current{
  margin-top:0.2rem;
}
/deep/ .el-calendar__header{
  display: none;
}
.her{
    width: 10rem;
    height: 4rem;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right:1.5rem;
    cursor: pointer;
}
.btnHer{
  display: flex;
  justify-content: end;
}
::v-deep {
    .el-calendar-table:not(.is-range) td.next,.el-calendar-table:not(.is-range) td.prev{
      pointer-events: none;
    }
  }

  /deep/.el-input input{
  color: #666 !important;
}
/deep/.el-form-item input,/deep/.el-date-editor{
  background: #fff !important;
  color: #666 !important;
}
/deep/ .el-radio-group span{
  color: #333 !important;
}
.son_border{
  border: 1px dashed #E8ECF4;
  display: flex;
  flex-wrap: wrap;
  padding: 2rem 0;
  box-sizing: border-box;
  margin-bottom: 2rem;
  ::v-deep .el-input{
    width: 27rem !important;
    margin-right: 5rem;
  }
  img{
    width: 4rem;
    height: 4rem;
    margin-left: 4.5rem;
    cursor: pointer;
  }
}
::v-deep .el-checkbox-group{
  flex-wrap: nowrap !important;
}
.conendTime /deep/.el-date-editor{
  width: auto !important;
}
.form_ages{
  display: flex;
  align-items: center;
  >span{
    margin: 0 2rem;
  }
}
</style>